export default __webpack_public_path__ + "2b8e76ab1a0a77e012c5268317bed261.png";